import { Input } from '@/new/components/shadcn/input';
import { Label } from '@/new/components/shadcn/label';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const FilenameField = ({ value, onChange }: Props) => (
  <div className="flex flex-col gap-2">
    <Label htmlFor="download-filename" className="text-sm font-medium text-gray-700">
      File Name
    </Label>
    <Input
      id="download-filename"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Enter a title for your file"
      className="w-full"
    />
  </div>
);
